import PropTypes from 'prop-types'
import { placements } from 'rc-tooltip/lib/placements'

/**
 * Proptype that represents the enumeration of valid tooltip placements
 * @typedef {'left'|
 *           'right'|
 *           'top'|
 *           'bottom'|
 *           'topLeft'|
 *           'leftTop'|
 *           'topRight'|
 *           'rightTop'|
 *           'bottomRight'|
 *           'rightBottom'|
 *           'bottomLeft'|
 *           'leftBottom'
 *          } Placement
 */
export const placementPropType = PropTypes.oneOf(Object.keys(placements))
